<div class="body">

    <div class="header-boleto-digital">
        <div class="btn-options">
            <button color="primary" (click)="close()" mat-icon-button matTooltip="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="lado-imagem">
            <img [src]="imglogo" alt="img-logo-unidade" class="img-logo">
        </div>
    </div>

    <div class="body-boleto-digital">
        <div class="div-img-boleto-digital">
            <img src="../../../../../../assets/boleto-digital.png" alt="img-boleto-digital" class="img-boleto-digital">
        </div>
        <div class="div-matcard-boleto-digital">
            <mat-card class="mat-card-boleto-digital">
                <div class="div-texto">
                    <p class="p-dados-pagamento">
                        <b>Dados para pagamento</b>
                    </p>
                    <p class="p-pagador">
                        <b>Pagador:</b>
                        {{ nomeAluno }}
                    </p>
                    <p class="p-data-vencimento">
                        <b>Data de vencimento:</b>
                        {{ pagamento.dataVencimento | date:'dd/MM/yyyy' }}
                    </p>
                    <p class="p-valor-boleto">
                        <b>Valor do boleto:</b>
                        {{ pagamento.valor | currency }}
                    </p>
                    <p class="p-valor-vencimento" *ngIf="pagamento.tipoSituacao == 1 || pagamento.tipoSituacao == 2 || pagamento.tipoSituacao == 3 || pagamento.tipoSituacao == 6">
                        <b>Valor até o vencimento:</b>
                        {{ pagamento.valorVencimento | currency }}
                    </p>
                    <p class="p-codigo-barras">
                        <b>Código de barras:</b>
                        {{ pagamento.numeroLinhaDigitavel }}
                    </p>
                </div>
                <div class="div-botao">
                    <button mat-raised-button class="botao-cod-barras" [cdkCopyToClipboard]="pagamento.numeroLinhaDigitavel" (click)="alertCopy()"> <!-- [cdkCopyToClipboard]="longText" - (click)="copyToClipboard(pagamento.numeroLinhaDigitavel)" -->
                        <p class="p-botao-cod-barras">
                            Copiar Código de Barras
                        </p>
                    </button>
                </div>
            </mat-card>
        </div>
    </div>

</div>